import React from 'react';
import { AvatarInitialsProps } from './types';
import { Wrapper, InitialsText } from './avatar-initials.styles';
import { getInitials } from './get-initials';

export const AvatarInitials: React.FC<AvatarInitialsProps> = ({ size = 'subtitle1', name, isOnlyName }) => {
    return (
        <Wrapper>
            <InitialsText size={size} color='neutral_00'>
                {getInitials(name || '', isOnlyName)}
            </InitialsText>
        </Wrapper>
    );
};
